
























import Vue, { PropType } from "vue";
import {
  Data,
  Methods,
  Computed,
  Props,
  OnboardingStatusType,
  StepRange
} from "./types";
import Overlay from "@/components/Atoms/Overlay/index.vue";
import Panel from "@/components/Organisms/OnboardingFloatingView/Organisms/Panel/index.vue";
import RecruitmentNumberForm from "@/components/Organisms/OnboardingFloatingView/Organisms/RecruitmentNumberForm/index.vue";
import UniversitiesForm from "@/components/Organisms/OnboardingFloatingView/Organisms/UniversitiesForm/index.vue";
import CompaniesForm from "@/components/Organisms/OnboardingFloatingView/Organisms/CompaniesForm/index.vue";
import { isNotNullOrUndefined } from "@/helpers/type-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "OnboardingFloatingView",
  components: {
    Overlay,
    Panel,
    RecruitmentNumberForm,
    UniversitiesForm,
    CompaniesForm
  },
  props: {
    isShow: {
      type: Boolean as PropType<Props["isShow"]>,
      required: true
    },
    loading: {
      type: Boolean as PropType<Props["loading"]>,
      required: true
    },
    currentStep: {
      type: Number as PropType<Props["currentStep"]>,
      required: true
    },
    onboardingStatus: {
      type: String as PropType<Props["onboardingStatus"]>,
      required: true
    },
    onboardingData: {
      type: Object as PropType<Props["onboardingData"]>,
      required: true
    }
  },
  data() {
    return {
      OnboardingStatusType
    };
  },
  computed: {
    stepSettings() {
      return [
        this.onboardingStatus === OnboardingStatusType.DONE_STEP1
          ? undefined
          : {
              heading: "採用人数の設定",
              subHeading: "おすすめの情報を表示する為の初期設定を行いましょう",
              disabledOnNext: isNaN(this.onboardingData.recruitmentNumber),
              componentSetting: {
                component: RecruitmentNumberForm,
                props: {
                  recruitmentNumber: this.onboardingData.recruitmentNumber
                },
                onChange: this.handleChangeRecruitmentNumber
              }
            },
        {
          heading: "フォローする大学を設定",
          subHeading:
            "フォローした大学の就活動向に関する重要な通知を受け取れます",
          disabledOnNext: !this.onboardingData.universities.length,
          componentSetting: {
            component: UniversitiesForm,
            props: {
              universities: this.onboardingData.universities
            },
            onChange: this.handleChangeUniversities
          }
        },
        {
          heading: "フォローする企業を設定",
          subHeading: `フォローした企業の新着イベントやクチコミ情報の通知を受け取れます
            ※ 自社は追加できません`,
          disabledOnNext: !this.onboardingData.companies.length,
          componentSetting: {
            component: CompaniesForm,
            props: {
              companies: this.onboardingData.companies
            },
            onChange: this.handleChangeCompanies
          }
        }
      ]
        .filter(isNotNullOrUndefined)
        .map((setting, i) => ({ ...setting, step: i + 1 }));
    },
    currentStepSetting() {
      const currentSetting = this.stepSettings.find(
        setting => setting.step === this.currentStep
      );
      if (currentSetting === undefined) {
        this.$emit("changeCurrentStep", StepRange.MIN_STEP);
      }
      return currentSetting!;
    }
  },
  methods: {
    handleClickNext() {
      if (this.currentStep < StepRange.MAX_STEP) {
        this.$emit("changeCurrentStep", this.currentStep + 1);
      }
    },
    handleClickBack() {
      if (this.currentStep > StepRange.MIN_STEP) {
        this.$emit("changeCurrentStep", this.currentStep - 1);
      }
    },
    handleClickSubmit() {
      this.$emit("compleatOnboarding");
    },
    handleChangeRecruitmentNumber(recruitmentNumber) {
      this.$emit("changeOnboardingData", {
        ...this.onboardingData,
        recruitmentNumber
      });
    },
    handleChangeUniversities(universities) {
      this.$emit("changeOnboardingData", {
        ...this.onboardingData,
        universities
      });
    },
    handleChangeCompanies(companies) {
      this.$emit("changeOnboardingData", {
        ...this.onboardingData,
        companies
      });
    }
  }
});
